import React, { useState, useEffect, useContext } from 'react';
import { LegacyStack, Modal, TextField } from '@shopify/polaris';
import {Util, SearchContext} from '@thinkwell/react.common'
import ClassroomRegistration from './ClassroomRegistration';

export default function ClassroomRegistrations(props) {
  const [query, setQuery] = useContext(SearchContext)

  const MIN_SEARCH_LENGTH = 2
  const [sectionsVisible, setSectionsVisible] = useState([]);
  const [retakeModalActive, setRetakeModalActive] = useState(false);

  if (props.onRetakeModalActive) {
    useEffect(() => props.onRetakeModalActive(retakeModalActive), [retakeModalActive])
  }
  useEffect(() => {
    if(!query || query.length < MIN_SEARCH_LENGTH) {
      setSectionsVisible([])
    } else {
      const filteredSections = props.sections.filter((section) => {
        const text = `${section.school} - ${section.course} - ${section.section}`
        return text.match(new RegExp(query, 'i'))
      })
      setSectionsVisible(filteredSections)
    }
  }, [props.sections, query]);

  Util.hideLoader();

  return (<div>
      <TextField
        id="classroom-search"
        type="text"
        value={query}
        onChange={setQuery}
        placeholder="Type your School Name and/or Course Title here"
      />
      <div className="registration-sections">
        {props.sections.map((section, index) => <ClassroomRegistration
          key={section.section_id}
          section={section}
          visible={sectionsVisible.indexOf(section) !== -1}
          onRetakeClicked={() => setRetakeModalActive(true)}
        /> )}
      </div>
      <Modal
        open={retakeModalActive}
        onClose={() => setRetakeModalActive(false)}
        title="Retake class"
        primaryAction={{
          content: 'Close',
          onAction: () => setRetakeModalActive(false),
        }}
      >
        <Modal.Section>
          <div className="colored-links">
          To retake this class, please <a href="/account/login">Sign In</a> and visit your <a href="/account">Account</a> page. You will have the option to retake classes based on your previous enrollments.
          </div>
        </Modal.Section>
      </Modal>
    </div>)
}
